import React from 'react';
import { Link } from 'react-router-dom';
import TableWrapServerSide from '@/components/ui/tables/TableWrapServerSide';
import IsLoadingNotFound   from '@/components/ui/tables/IsLoadingNotFound';
import PermissionCheck     from '@/components/common/PermissionCheck';

/**
 * Waiters DataTable
 * • Points all “view/edit/delete” links at /admin/waiters/…
 * • Uses same employee permissions for now
 */
const DataTable = ({
  isLoading,
  tableColumn,
  dataSource,
  totalRecord,
  dataFilter,
  onChangePage,
  handleDrawerOpen,
  deleteRecord,
}) => (
  <TableWrapServerSide
    tableColumnList={tableColumn}
    totalDataCount={totalRecord}
    initialPage={dataFilter?.page}
    onChangePage={onChangePage}
    per_page={dataFilter?.limit}
  >
    {dataSource.length > 0 ? (
      dataSource.map((waiter) => (
        <tr className="db-table-body-tr" key={waiter._id}>
          <td className="db-table-body-td">{waiter.name}</td>
          <td className="db-table-body-td">{waiter.email}</td>
          <td className="db-table-body-td">{waiter.phone_no}</td>
          <td className="db-table-body-td">{waiter?.role_id?.name}</td>
          <td className="db-table-body-td">
            {waiter.status === 1
              ? <span className="active">Active</span>
              : <span className="inactive">Inactive</span>}
          </td>
          <td className="db-table-body-td">{waiter.salary}</td>
          <td className="db-table-body-td hidden-print hidden-print-remove">
            <div className="flex items-center gap-1.5">
              {/* View */}
              <PermissionCheck permsission="view_employees">
                <Link
                  to={`/admin/waiters/show/${waiter._id}`}
                  className="db-table-action view"
                  state={{ waiter }}
                >
                  <i className="lab lab-view" />
                  <span className="db-tooltip">View</span>
                </Link>
              </PermissionCheck>

              {/* Edit */}
              <PermissionCheck permsission="update_employees">
                <button
                  data-modal="#sidebar"
                  className="db-table-action edit"
                  onClick={() => handleDrawerOpen(waiter._id)}
                >
                  <i className="lab lab-edit-line" />
                  <span className="db-tooltip">Edit</span>
                </button>
              </PermissionCheck>

              {/* Delete */}
              <PermissionCheck permsission="delete_employees">
                <button
                  className="db-table-action delete"
                  onClick={() => deleteRecord(waiter._id)}
                >
                  <i className="lab lab-delete" />
                  <span className="db-tooltip">Delete</span>
                </button>
              </PermissionCheck>
            </div>
          </td>
        </tr>
      ))
    ) : (
      <IsLoadingNotFound
        isLoading={isLoading}
        colSpan={tableColumn.length}
      />
    )}
  </TableWrapServerSide>
);

export default DataTable;
